import React, { useContext } from 'react';
import ConnectContext from '../context/connectContext';

const ChatConnectFooter = () => {
  const { trans, sb, activeLang } = useContext(ConnectContext);
  const _markAllAsRead = () => {
    const channelListQuery = sb.GroupChannel.createMyGroupChannelListQuery();
    channelListQuery.limit = 30;
    if (channelListQuery.hasNext) {
      channelListQuery.next((channelList, error) => {
        if (error) {
          return;
        }
        Object.keys(channelList).forEach(key => {
          channelList[key].markAsRead();
        });
      });
    }
  };

  let langUrl = '';
  if (activeLang !== 'en') {
    langUrl = `/${activeLang}`;
  }

  return (
    <div className="chat-connect-footer">
      <a href={`${langUrl}/chat`}>{trans['See All Messages']}</a>
      <button onClick={_markAllAsRead} type="button">
        {trans['Mark All as Read']}
      </button>
    </div>
  );
};

export default ChatConnectFooter;
